import React from 'react'
import * as C from './styles'

const Hamburger = () => {
  return (
    <C.HamburgerInput type={'checkbox'} ariaLabel={'Menu'}/>
  )
}

export default Hamburger